<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <b-button variant="success mr-1" @click="save">Save</b-button>
          <b-button variant="warning" @click="close">Close</b-button>
        </div>
      </div>
      <simpleFormVue :itemSimpleForm="itemSimpleForm" :$v="$v" :model="model" />
    </b-card>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import simpleFormVue from "../../components/simpleForm.vue";
toastr.init();

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  components: { Loading, simpleFormVue },
  mixins: [validationMixin],
  validations: {
    model: {
      customerID: { required },
      debtorFullName: { required },
      genderCode: { required },
      mobilePhoneNumber: { required },
      maritalStatus: { required },
    },
  },
  data() {
    return {
      showFilter: true,
      isBusy: false,
      isLoading: false,
      isInsert: true,
      model: {
        borrowerKey: "",
        customerID: "",
        debtorFullName: "",
        genderCode: "",
        estimatedYearlyGrossIncome: "",
        mobilePhoneNumber: "",
        placeOfBirth: "",
        dateOfBirth: "",
        professionCode: "",
        employerName: "",
        employerIndustryCode: "",
        motherMaidenName: "",
        maritalStatus: "",
        monthlyIncome: "",
        citizen: "",
        religion: "",
        address: "",
        country: "",
        province: "",
        city: "",
        district: "",
        subDistrict: "",
      },
      itemSimpleForm: {
        debtorFullName: { label: "Debtor Fullname", type: "text", col: 6 },
        genderCode: {
          label: "Gender Code",
          type: "select",
          options: [],
          col: 6,
        },
        idType: { type: "text", col: 6 },
        customerID: { type: "text" },
        idNumber: { type: "text", col: 6 },
        estimatedYearlyGrossIncome: { type: "text", col: 6 },
        sourceOfIncome: { type: "text", col: 6 },
        leasePhoneNumber: { type: "text", col: 6 },
        mobilePhoneNumber: { type: "text", col: 6 },
        placeOfBirth: { type: "text", col: 6 },
        dateOfBirth: { type: "date", col: 6 },
        professionCode: { type: "text", col: 6 },
        employerIndustryCode: { type: "text", col: 6 },
        employerName: { type: "text" },
        motherMaidenName: { type: "text", col: 6 },
        maritalStatus: { type: "select", options: [], col: 6 },
        monthlyIncomeCode: { type: "text", col: 6 },
        monthlyIncome: { type: "number", col: 6 },
        citizen: { type: "text" },
        religion: { type: "select", options: [] },
        email: { type: "text" },
        lastEducationCode: { type: "text" },
        address: { type: "textarea" },
        country: { type: "text", col: 6 },
        province: { type: "text", col: 6 },
        city: { type: "text", col: 6 },
        district: { type: "text", col: 6 },
        subDistrict: { type: "text", col: 6 },
        postalCode: { type: "text", col: 6 },
      },
      // [] = array
      // {} = obj
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      console.log(this.$v.model);
      return this.$v.model.$invalid;
    },
  },
  async created() {
    try {
      toastr.info("Loading Borrower Form, Please Wait...");
      this.isLoading = true;
      let maritalstatus = await crud.list({ tablename: "maritalstatus" });
      this.itemSimpleForm["maritalStatus"].options = maritalstatus.reduce(
        (
          list = [{ value: "", text: "Please select an option" }],
          data,
          index
        ) => {
          list.push({
            value: data.marital_status_code,
            text: data.marital_status_name,
          });
          return list;
        },
        [{ value: "", text: "Please select an option" }]
      );

      this.itemSimpleForm["genderCode"].options = dropdown.gendersId.reduce(
        (
          list = [{ value: "", text: "Please select an option" }],
          data,
          index
        ) => {
          list.push({ value: data.value, text: data.text });
          return list;
        },
        [{ value: "", text: "Please select an option" }]
      );

      let religion = await crud.list({ tablename: "religion" });
      this.itemSimpleForm["religion"].options = religion.reduce(
        (
          list = [{ value: "", text: "Please select an option" }],
          data,
          index
        ) => {
          list.push({ value: data.religion_code, text: data.religion_name });
          return list;
        },
        [{ value: "", text: "Please select an option" }]
      );

      if (this.$route.params.borrowerKey) {
        this.isInsert = false;
        const data = await crud.detail({
          tablename: "borrowercrud",
          key: this.$route.params.borrowerKey,
        });
        const row = data;
        for (var key in row) {
          this.model[key] = row[key];
        }
        this.$forceUpdate();
      }
      toastr.clear;
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      console.log("error : ", error);
      toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
    }
  },
  methods: {
    save: async function () {
      try {
        if (this.invalidModel) {
          toastr.error("Please fill the form correctly.", "Error Info");
        } else {
          this.isLoading = true;
          let tablename = "borrower";
          let data = {
            borrowerKey: this.model.borrowerKey,
            customerID: this.model.customerID,
            debtorFullName: this.model.debtorFullName,
            genderCode: this.model.genderCode,
            estimatedYearlyGrossIncome: this.model.estimatedYearlyGrossIncome,
            mobilePhoneNumber: this.model.mobilePhoneNumber,
            placeOfBirth: this.model.placeOfBirth,
            dateOfBirth: moment(this.model.dateOfBirth).format("YYYY-MM-DD"),
            professionCode: this.model.professionCode,
            employerName: this.model.employerName,
            employerIndustryCode: this.model.employerIndustryCode,
            motherMaidenName: this.model.motherMaidenName,
            maritalStatus: this.model.maritalStatus,
            monthlyIncome: this.model.monthlyIncome,
            citizen: this.model.citizen,
            religion: this.model.religion,
            address: this.model.address,
            country: this.model.country,
            province: this.model.province,
            city: this.model.city,
            district: this.model.district,
            subDistrict: this.model.subDistrict,
          };

          if (!this.isInsert) {
            await crud.update({
              tablename,
              key: this.model.borrowerKey,
              data,
            });
          } else {
            await crud.insert({
              tablename,
              data,
            });
          }
          this.isLoading = false;
          toastr.success(`Success save borrower.`, "Save Borrower", 10000);
          this.close();
        }
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    close() {
      router.push({ name: "master.borrower" });
    },
  },
};
</script>